(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/session/assets/javascripts/account_balance.js') >= 0) return;  svs.modules.push('/components/core/session/assets/javascripts/account_balance.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.core = svs.core || {};
  svs.core.session = svs.core.session || {};

  svs.core.session.AccountBalance = function() {
    var self,
      lastUpdated = null,
      accountBalance = null,
      BALANCE_CACHE_TIME = 3 * 60 * 1000, 
      log = new svs.core.log.Logger('svs.core.session.AccountBalance');

    var get = function(forceRetrieveBalanceFromJupiter, callback, context) {
      if (typeof forceRetrieveBalanceFromJupiter === 'function') {
        callback = forceRetrieveBalanceFromJupiter;
        context = callback;
        forceRetrieveBalanceFromJupiter = false;
      }

      log.debug('Getting account balance');

      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        if (
          !forceRetrieveBalanceFromJupiter &&
          accountBalance &&
          lastUpdated &&
          Date.now() - lastUpdated < BALANCE_CACHE_TIME
        ) {
          if (callback) {
            log.debug('Get cached balance');
            callback.call(context, accountBalance);
          }
        } else {
          try {
            log.debug('Get balance from jupiter');
            svs.core.jupiter.call(
              { method: 'GET', path: '/player/info?include=accountBalance' },
              function(response) {
                log.debug('Account balance retrieved.');

                var retrievedAccountBalance = response.accountBalance;
                set(retrievedAccountBalance);

                if (callback) {
                  callback.call(context, retrievedAccountBalance);
                }
              },
              function(jqXHR, textStatus, err) {
                var error = 'Failed to retrieve account balance.';
                if (err) {
                  error += ' Error: ' + err;
                }
                log.error(error);

                if (callback) {
                  callback.call(context, accountBalance, err);
                }
              }
            );
          } catch (ex) {
            log.error(
              'Generic error: Failed to retrieve account balance, error: ' +
                ex.message +
                '.' +
                ex.stack
            );

            if (callback) {
              callback.call(context, accountBalance, ex);
            }
          }
        }
      } else {
        if (callback) {
          callback.call(context, null);
        }
      }
    };

    var set = function(newAccountBalance) {
      lastUpdated = Date.now();

      if (newAccountBalance !== accountBalance) {
        accountBalance = newAccountBalance;
        self.trigger('change', accountBalance);
      }
    };

    self = new svs.core.Events({
      get: get,
      set: set
    });
    return self;
  };
})(svs);

 })(window);